export const noItemsSelected = "KHo3Z";
export const oneItemSelected = "Q$pJDd";
export const someItemsSelected = "Bs9y0b";
export default {noItemsSelected,oneItemSelected,someItemsSelected};